import { render } from "./ContentHeader.vue?vue&type=template&id=6b86c87a&scoped=true&ts=true"
import script from "./ContentHeader.vue?vue&type=script&lang=ts"
export * from "./ContentHeader.vue?vue&type=script&lang=ts"

import "./ContentHeader.vue?vue&type=style&index=0&id=6b86c87a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b86c87a"]])

export default __exports__